'use client';

import React from 'react';

import type { PagesQuery } from '../../graphql/generated/schema';
import { BlockSettings_Margin_MarginBottom } from '../../graphql/generated/schema';
import type { IconType } from '../../components';
import { AppImage, Icon } from '../../components';
import { BlockContainer } from '../../components/layouts';
import type { ExtractLayoutType, SharedBlockType } from '../types';
import styles from './styles.module.scss';
import { StickyImageScrollContent } from './components';
import { constructClassName } from '../../utils/constructClassName';

export const StickyImageScroll: React.FC<SharedBlockType & ExtractLayoutType<PagesQuery, 'StickyImageScroll'>> = ({
  blockSettings,
  image,
  items,
}) => {
  const [activeIndex, setActiveIndex] = React.useState(0);

  return (
    <BlockContainer
      blockSettings={{
        margin: {
          // eslint-disable-next-line camelcase
          marginBottom: BlockSettings_Margin_MarginBottom.None,
        },
        padding: blockSettings?.padding,
      }}
    >
      <div className={styles.container}>
        <div className={styles.listContainer}>
          {items?.map((item, index) => (
            <StickyImageScrollContent
              key={index}
              content={item?.content}
              index={index}
              setActiveIndex={setActiveIndex}
            />
          ))}
        </div>
        <div className={styles.imageContainer}>
          <div className={styles.imageInnerContainer}>
            <AppImage
              imageSize="original"
              image={image}
              className={styles.image}
            />
            {
              items?.filter((item) => item.showImageNode)?.map((item, index) => (
                <div
                  key={index}
                  className={constructClassName([
                    styles.imageNodeIcon,
                    activeIndex === index && styles.activeImageNodeIcon,
                  ])}
                  style={{
                    top: `${((item.imageNode?.y || 0) / (image?.height || 1)) * 100}%`,
                    left: `${((item.imageNode?.x || 0) / (image?.width || 1)) * 100}%`,
                  }}
                >
                  <Icon
                    icon={item.imageNode?.icon as IconType}
                    size={24}
                  />
                </div>
              ))
            }
          </div>
        </div>
      </div>
    </BlockContainer>
  );
};
